import React from "react";
import { Check, X } from "lucide-react";
import { useT } from "../../lib/lang";

// Iter96 — Phase 2B floating draw-finish controls (spec §4.3/§5.1).
//
// Primary mechanism for closing a polygon / finishing a line on touch
// devices (no keyboard => no "Enter"/"Escape"). Also shown on desktop
// for a consistent, discoverable UI — the native desktop gestures
// (click first point, double-click last point, real Enter/Escape keys)
// keep working in parallel, this button is simply an additional path to
// the SAME `finishCurrentDrawing()`/`cancelCurrentDrawing()` calls.
//
// Positioned bottom-center with safe-area padding so it never sits
// under an iPhone home-indicator / Android gesture bar, and stays clear
// of the toolbar (top-left) and side panel (right) — spec §4.3
// "respect des zones de sécurité de l'écran" / "aucun conflit avec le
// déplacement de la carte" (buttons, not map gestures, so no conflict).
export const PlanificationDrawActions = ({ kind, canFinish, onFinish, onCancel }) => {
  const [t] = useT();
  if (!kind) return null;
  const finishLabel = kind === "polygon" ? t.planificationClosePolygon : t.planificationFinishLine;
  return (
    <div
      className="absolute left-1/2 -translate-x-1/2 z-[470] flex items-center gap-2"
      style={{ bottom: "max(1.5rem, calc(env(safe-area-inset-bottom) + 1rem))" }}
      data-testid="planification-draw-actions"
    >
      <button
        type="button"
        data-testid="planification-cancel-drawing-btn"
        onClick={onCancel}
        title={t.planificationCancelDrawing}
        aria-label={t.planificationCancelDrawing}
        className="flex items-center justify-center w-11 h-11 rounded-full bg-[#111418]/95 backdrop-blur border border-zinc-700 text-zinc-300 hover:text-red-300 hover:border-red-400/60 active:scale-95 transition-all"
      >
        <X className="w-5 h-5" />
      </button>
      {canFinish && (
        <button
          type="button"
          data-testid="planification-finish-drawing-btn"
          onClick={onFinish}
          title={finishLabel}
          aria-label={finishLabel}
          className="flex items-center gap-2 px-4 h-11 rounded-full bg-emerald-500 text-black font-semibold text-sm shadow-lg active:scale-95 transition-all"
        >
          <Check className="w-4 h-4" />
          {finishLabel}
        </button>
      )}
    </div>
  );
};
